import { c as _c } from "react/compiler-runtime";
import type { DropMetadata } from "@/entities/IDrop";
export default function CreateDropMetadataItem(t0) {
  const $ = _c(16);
  const {
    item: t1,
    onMetadataRemove,
    disabled: t2
  } = t0;
  const {
    data_key,
    data_value
  } = t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== data_key) {
    t3 = <span className="tw-font-bold"> {data_key}</span>;
    $[0] = data_key;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== data_value || $[3] !== t3) {
    t4 = <p className="tw-mb-0 tw-max-w-xl tw-truncate tw-text-sm tw-font-medium tw-text-iron-50">{t3}: {data_value}</p>;
    $[2] = data_value;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== data_key || $[6] !== disabled || $[7] !== onMetadataRemove) {
    t5 = () => {
      if (!disabled) {
        onMetadataRemove(data_key);
      }
    };
    $[5] = data_key;
    $[6] = disabled;
    $[7] = onMetadataRemove;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-red tw-transition tw-duration-300 tw-ease-out group-hover:tw-scale-110" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== disabled || $[11] !== t5) {
    t7 = <button onClick={t5} aria-label="Remove file" disabled={disabled} type="button" className="tw-group tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-p-1.5 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-800">{t6}</button>;
    $[10] = disabled;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <div className="tw-rounded-lg tw-px-3 tw-py-1 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out hover:tw-ring-iron-600"><div className="tw-flex tw-items-center tw-gap-x-3"><div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-2 tw-truncate">{t4}{t7}</div></div></div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}